import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { IconButton, Stack, Typography } from "@mui/material";
import { type FC } from "react";
import { HANDLING_COPY } from "./handling-ui";

interface OpportunityHandlingEntryNoticeProps {
  managerName: string;
  onDismiss: () => void;
}

export const OpportunityHandlingEntryNotice: FC<
  OpportunityHandlingEntryNoticeProps
> = ({ managerName, onDismiss }) => (
  <Stack
    direction="row"
    alignItems="flex-start"
    gap={1}
    px={1.5}
    py={1}
    mb={1}
    borderRadius="0.75rem"
    border="1px solid"
    borderColor="divider"
    bgcolor="rgba(5, 32, 76, 0.04)"
  >
    <PersonOutlineIcon
      fontSize="small"
      sx={{ color: "text.secondary", mt: 0.15, flexShrink: 0 }}
    />
    <Typography
      variant="body2"
      color="text.secondary"
      fontSize="0.875rem"
      lineHeight={1.45}
      flex={1}
    >
      {HANDLING_COPY.entryNotice(managerName)}
    </Typography>
    <IconButton
      size="small"
      aria-label="סגור הודעה"
      onClick={onDismiss}
      sx={{ mt: -0.25, color: "text.secondary" }}
    >
      <CloseRoundedIcon fontSize="small" />
    </IconButton>
  </Stack>
);
